import React from 'react'
import { useRouter } from 'next/dist/client/router'

import { storage } from '../../storage'

interface UseCartID {
  cartID: string
  setCartID: (cID: string) => unknown
  removeCartID: () => unknown
}

const useCartID = (): UseCartID => {
  const router = useRouter()
  const storedCartID = (router.query.cID as string) || ''
  const [cartID, _setCartID] = React.useState(storedCartID)
  const setCartID = (cID: string) => {
    storage.setCartID(cID)
    _setCartID(cID)
  }
  const removeCartID = () => {
    storage.removeCartID()
    _setCartID('')
  }

  React.useEffect(() => {
    const cID = storage.getCartID()
    if (cID && !cartID) {
      _setCartID(cID)
    }
  }, [cartID, _setCartID])

  return { cartID, setCartID, removeCartID }
}

export default useCartID
